export { default } from './DestacatLateral';
